// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import App from './App'
import moment from 'moment-timezone'
import vSelect from 'vue-select'
import store from './store'
moment.tz.setDefault("America/Los_Angeles");

import router from './router'
import './PeteHealthData'
// todo
// cssVars()
Vue.component('v-select', vSelect)
Vue.use(VueMaterial)
Vue.use(VueVirtualScroller)
Vue.prototype.moment = moment
Vue.use(BootstrapVue)
Vue.use(VueGoogleMaps, {
  load: {
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "visualization"],
    // (as you require)
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  store,
  components: {
    App
  },
  computed: {
    therapist_opts: function() {

      if (!this.therapists) {
        this.getTherapists()
      }

      return !this.therapists || this.therapists.length < 1 ? [] : this.therapists.map(t => { return {value:t.id, text: `${t.last_name}, ${t.first_name}`} })
    },
    active_cases: function() {
      if(!this.current_cases) {
        this.getCurrentCases()
      }

      return !this.current_cases || this.current_cases.length < 1 ? [] : this.current_cases
    },
    active_cases_with_payers: function() {

      return this.active_cases.map(c => {
        return {...c, ...{
          ins1: this.getPayerById(c.ins1_id),
          ins2: this.getPayerById(c.ins2_id),
          ins3: this.getPayerById(c.ins3_id),
        }}
      })
    },
    all_payers: function() {
      if (!this.payers) {
        this.getPayers()
      }

      return !this.payers || this.payers.length < 1 ? [] : this.payers
    },
    payer_opts: function() {
      return this.all_payers.map(p => { return {
        value: p.id,
        text: p.name,
        cl_id: p.cl_id
      } })
    },
    all_doctors: function() {
      if (!this.doctors) {
        this.getDoctors()
      }

      return !this.doctors || this.doctors.length < 1 ? [] : this.doctors
    },
    doctor_opts: function() {
      return this.all_doctors.map(d => { return {
        value: d.id,
        text: `${d.last_name}, ${d.first_name}`,
      } })
    },
  },
  data: function() {
    return {
      therapists: [],
      current_cases: null,
      payers: null,
      doctors: null,
    }
  },
  methods: {
    getTherapists(refresh) {
      if (!this.therapists || refresh) {
        this.$newpetehealthapi.get('/therapists').then(r => this.therapists = r.data).catch(e => console.log(e))
      }

      return this.therapists
    },
    getCurrentCases(refresh) {
      console.log('depracated: must use getCurrentCasesForTherapist with an ID instead');
      /*
      if (!this.current_cases || refresh) {
        this.$newpetehealthapi.get('/tportal').then(r => { this.current_cases = r.data }).catch(e => console.log(e))
      }
      */

      return this.current_cases
    },
    getCurrentCasesForTherapist(therapist_id) {
      this.$newpetehealthapi.get('/tportal/'+therapist_id).then(r => { this.current_cases = r.data }).catch(e => console.log(e))
    },
    getPayers(refresh) {
      if (!this.payers || refresh) {
        this.$newpetehealthapi.get('/payers').then(r => { this.payers = r.data }).catch(e => console.log(e))
      }

      return this.payers
    },
    getDoctors(refresh) {
      if (!this.doctors || refresh) {
        this.$newpetehealthapi.get('/doctors').then(r => { this.doctors = r.data }).catch(e => console.log(e))
      }

      return this.doctors
    },
    getPayerById(id) {
      return this.all_payers.find(v => {
        return v.id == id
      })
    },
    saveLead(lead) {
      return this.$newpetehealthapi.post('/leads' + (lead.id ? '/'+lead.id : ''), lead )
    }
  },
})
